// Reducer
const INITIAL_STATE = {
  slots: [],
  articleHeight: 50,
};

export default function AdTest(state = INITIAL_STATE) {
  return state;
}
/* eslint-enable no-case-declarations */
